import React, { Fragment, FunctionComponent } from "react";
import { connect, MapStateToProps } from "react-redux";

import { Divider } from "@multiweb/reactComponents";
import { IAppState } from "@multiweb/types/react";
import { isStatusViewEnabled } from "../../selectors";
import { WorkflowEditorProps } from "../../types";
import { LegendContainer, SetPropertiesContainer, VariablesContainer } from "./containers";

type GeneralPropertyPanelComponentProps = {
    readonly isStatusViewEnabled: boolean;
} & WorkflowEditorProps;

const GeneralPropertyPanelComponent: FunctionComponent<GeneralPropertyPanelComponentProps> = ({ hostKey, isStatusViewEnabled }) => (
    <Fragment>
        {isStatusViewEnabled &&
            <Fragment>
                <VariablesContainer {...{ hostKey }} />
                <Divider />
            </Fragment>
        }
        <SetPropertiesContainer {...{ hostKey }} />
        <Divider />
        <LegendContainer {...{ hostKey }} />
        <Divider />
    </Fragment>
);

type StateProps = Pick<GeneralPropertyPanelComponentProps, "isStatusViewEnabled">;

const mapStateToProps: MapStateToProps<StateProps, WorkflowEditorProps, IAppState> = (state, { hostKey }) => ({
    isStatusViewEnabled: isStatusViewEnabled(state, hostKey),
});

export const GeneralPropertyPanel = connect(mapStateToProps)(GeneralPropertyPanelComponent);
